/**
 * Utilitaires de correction d'espacement consolidés
 * Ce fichier combine spacingFix.ts et immediateSpacingFix.ts
 */

// Injecter un style immédiatement pour éviter tout flashage de contenu
(function() {
  const style = document.createElement('style');
  style.textContent = `
    /* Supprimer les marges et espacements indésirables */
    body, html {
      margin: 0 !important;
      padding: 0 !important;
      overflow-x: hidden !important;
    }

    /* Garantir que la navbar est bien positionnée */
    header.fixed {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 50 !important;
    }

    /* Assurer que la section hero commence immédiatement après la navbar (fond sous la navbar) */
    .hero-section {
      margin-top: 0 !important;
      padding-top: calc(var(--navbar-height) + 40px) !important;
    }

    /* Supprimer tout espacement dans le conteneur principal */
    #app {
      margin: 0 !important;
      padding: 0 !important;
      background-color: #131313 !important;
    }

    /* Supprimer tout espacement entre les éléments principaux */
    main {
      margin-top: 0 !important;
      padding-top: 0 !important; /* le padding est géré sur la première section */
    }

    /* Par défaut, appliquer un offset à la première section sous la navbar */
    main > section:first-child:not(.blog-header):not(.hero-section) {
      padding-top: calc(var(--navbar-height) + 12px) !important;
    }
    body.has-navbar > section:first-of-type {
      padding-top: calc(var(--navbar-height) + 12px) !important;
    }
  `;
  document.head.appendChild(style);
})();

/**
 * Fonction optimisée qui corrige les problèmes d'espacement
 * Cette fonction combine les approches de spacingFix et immediateSpacingFix
 */
export function fixSpacing(): void {
  // Cibler directement les éléments problématiques
  const elementsToFix = [
    'body',
    'html',
    '#app',
    'main',
    '.hero-section',
    'header.fixed + *',
    '#app > div',
    '.bg-won-light',
    'section',
    'section.hero-section',
    'header.fixed',
    '.article-content'
  ];

  // Appliquer les corrections de style
  elementsToFix.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      const element = el as HTMLElement;

      // Modifier les styles selon le type d'élément
      if (selector === '.hero-section') {
        element.style.marginTop = '0';
        (element as HTMLElement).style.setProperty('padding-top', 'calc(var(--navbar-height) + 12px)');
      } else if (selector === 'body' || selector === 'html' || selector === '#app' || selector === '.bg-won-light') {
        element.style.backgroundColor = '#131313';
        element.style.marginTop = '0';
        element.style.paddingTop = '0';
      } else {
        element.style.marginTop = '0';
      }
    });
  });

  // Récupérer la hauteur réelle de la navbar (#navbar-surface si présent)
  const navSurface = document.getElementById('navbar-surface') || document.querySelector('header.fixed');
  if (navSurface) {
    const navHeight = (navSurface as HTMLElement).offsetHeight || (navSurface as HTMLElement).getBoundingClientRect().height || 80;
    // Mettre à jour la variable CSS pour usage global
    document.documentElement.style.setProperty('--navbar-height', `${navHeight}px`);
  }

  // Corriger directement les éléments avec une classe bg-gray
  const grayBands = document.querySelectorAll('[class*="bg-gray"]');
  grayBands.forEach(band => {
    (band as HTMLElement).style.backgroundColor = '#131313';
  });
}

/**
 * Fonction complète qui applique les correctifs d'espacement
 * et configure les écouteurs pour maintenir les corrections
 */
export function applySpacingFix(): void {
  // Appliquer immédiatement
  fixSpacing();

  // Appliquer quand le DOM est chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSpacing);
  }

  // Vérifier à nouveau après un délai pour capturer les modifications tardives du DOM
  setTimeout(fixSpacing, 100);
  setTimeout(fixSpacing, 500);
  setTimeout(fixSpacing, 1000);

  // Appliquer après le chargement complet de la page et ses ressources
  window.addEventListener('load', fixSpacing);

  // S'adapter si la fenêtre est redimensionnée
  window.addEventListener('resize', fixSpacing);
}

// Exporter une fonction simple pour un correctif rapide et ciblé
export function applyQuickFix(): void {
  // Corriger uniquement l'élément crucial - la section hero
  const heroSection = document.querySelector('.hero-section');
  if (heroSection) {
    (heroSection as HTMLElement).style.marginTop = '0';
    (heroSection as HTMLElement).style.setProperty('padding-top', 'calc(var(--navbar-height) + 12px)');
  }
}

// Exécuter la fonction par défaut si le script est importé directement
applySpacingFix();
